module.exports = __webpack_public_path__ + "packs/media/images/box_1-74f64ea160c8f02c753097dd460877c3.png";